import * as z from 'zod';

import { addressQuerySchema } from './address-query-schema';
import { uspsValidationStatusSchema } from './address-validation-schema';
import { addressTypeSchema } from './shared-schema';

export const addressMutationSchema = addressQuerySchema
  .pick({
    address1: true,
    address2: true,
    region: true,
  })
  .extend({
    id: z.number().optional(),
    type: addressTypeSchema,
    city: z.string().nullable(),
    postal_code: z.string(),
    state_id: z.number().nullable(),
    country_id: z.number().nullable(),
    usps_validation_status: uspsValidationStatusSchema.default('unverified'),
  });

export type AddressMutationSchema = z.infer<typeof addressMutationSchema>;
